import { TextFieldRow, SectionHeader, EmailTextFieldRow } from 'components';
import { useCreateDispatches } from 'helpers/hooks';
import { useSelector } from 'react-redux';
import { reinviteContributor } from 'services';
import styles from '../resourceParents.module.css';

export default function RPBasicInfo({ inputs, status, id }) {
	const rp = useSelector((state) => state.homes.resourceParent);

	const { setLoader, setSnackbar } = useCreateDispatches();

	const inputMap = inputs?.map((val) => {
		if (!val.value) {
			val.value = '';
		}

		const onResendInvite = () => {
			setLoader(true);
			reinviteContributor(id)
				.then(() => {
					setSnackbar({
						variant: 'success',
						message: 'Reinvite Successfull',
					});
					setLoader(false);
				})
				.catch(() => setLoader(false));
		};

		return val.label === 'Email' ? (
			<EmailTextFieldRow
				key={val.label}
				{...val}
				status={status}
				variant='outlined'
				//	name={key}
				onResend={onResendInvite}
			/>
		) : (
			<TextFieldRow key={val.label} variant='outlined' {...val} />
		);
	});

	return (
		<>
			<SectionHeader>RESOURCE PARENT INFORMATION</SectionHeader>
			<div className={styles.rpBasicInfoRoot}>{inputMap}</div>
		</>
	);
}
